import { useTranslation } from "react-i18next";
import { GrantRole } from "../../../../autogen/bff-api";

export const useGrantRoleName = () => {
  const { t } = useTranslation();
  return (role: GrantRole): string => {
    switch (role) {
      case GrantRole.Owner:
        return t("Owner");
      case GrantRole.Admin:
        return t("Admin");
      case GrantRole.SourcingCreator:
        return t("Sourcing Creator");
      case GrantRole.SourcingViewer:
        return t("Sourcing Viewer");
      case GrantRole.ContractCreator:
        return t("Contract Creator");
      case GrantRole.ContractViewer:
        return t("Contract Viewer");
      case GrantRole.ProjectCreator:
        return t("Project Creator");
      case GrantRole.ProjectViewer:
        return t("Project Viewer");
      case GrantRole.Creator:
        return t("Sourcing Creator");
      case GrantRole.Viewer:
        return t("Sourcing Viewer");
    }
  };
};
